import React from 'react';
import { SLoading } from '../../styles/components/Loading';
import { loadingAnimate } from '../../variants';
import { motion } from "framer-motion";


const Loading: React.FC = () => {
  return (
    <SLoading
      variants={loadingAnimate}
      initial='initial'
      animate='animate'
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
      />
    </SLoading>
  );
}

export default Loading;